import styled from '@emotion/styled'

export const Item = styled.div`
  align-items: flex-start;
  background: white;
  border-radius: 1rem;
  box-shadow: 0px 4px 20px 0px #E7E7E9;
  display: flex;
  flex-basis: calc(50% - 1.5rem);
  flex-direction: column;
  gap: 1rem;
  padding: 2rem;

  @media (max-width: 768px) {
    flex-basis: unset;
  }
`
